import Plus from '@assets/icons/plus.svg'
import { Icon } from './Icon'

export const PlusIcon = Icon(Plus)
